import { render, staticRenderFns } from "./MedicalSearch.vue?vue&type=template&id=038edf57&scoped=true"
import script from "./MedicalSearch.vue?vue&type=script&lang=js"
export * from "./MedicalSearch.vue?vue&type=script&lang=js"
import style0 from "./MedicalSearch.vue?vue&type=style&index=0&id=038edf57&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038edf57",
  null
  
)

export default component.exports